var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A4",
    transform: "translate(-225.000000, -680.000000)",
    fill: "#008200",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Verification-/-Green-Tick",
    transform: "translate(225.000000, 680.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0712661,0.242827686 C15.2133402,0.00603755333 15.5204703,-0.0707449786 15.7572604,0.0713291012 C15.9940505,0.213403181 16.0708331,0.520533309 15.928759,0.757323442 L6.928759,15.7573234 C6.92335283,15.7663337 6.91770767,15.7751123 6.9118365,15.783656 C6.90337642,15.7959557 6.89407535,15.8082252 6.88412318,15.8201678 C6.87129686,15.8353001 6.86352573,15.8437253 6.85551248,15.8518367 L6.88412318,15.8201678 C6.86284386,15.8457029 6.8395578,15.8685797 6.81468645,15.8887598 C6.80859723,15.8937316 6.80277813,15.8982215 6.79687388,15.9025724 C6.77966147,15.915295 6.76140213,15.9270161 6.74257803,15.9374501 C6.73407192,15.9420964 6.72554822,15.9464948 6.71691538,15.9506408 C6.70068702,15.958514 6.68408254,15.9654073 6.66720249,15.9713773 C6.65399538,15.9759916 6.64045113,15.9801574 6.62675667,15.983745 C6.61185205,15.987677 6.5967862,15.9908772 6.58161501,15.99338 C6.57392057,15.9946571 6.56627752,15.9957439 6.55860921,15.9966543 C6.53882069,15.998969 6.51875064,16.000089 6.4986622,16.000089 C6.48699779,16.000089 6.47565544,15.9997096 6.46431502,15.9989072 C6.44642281,15.9975788 6.428369,15.9953228 6.41043931,15.9920756 C6.38732119,15.9879204 6.36433357,15.9820427 6.34166014,15.9744501 C6.33849266,15.9734237 6.33519163,15.9722852 6.33189959,15.9711106 C6.30137671,15.9601311 6.27155091,15.9460938 6.24276466,15.928822 L6.2818803,15.9501154 C6.27040601,15.9445429 6.25908731,15.9384995 6.24795138,15.9319825 C6.23375438,15.9234159 6.22497578,15.9177707 6.21643211,15.9118995 C6.20413245,15.9034394 6.19186295,15.8941384 6.17992034,15.8841862 L0.179920337,10.8841862 C-0.0322181112,10.7074042 -0.0608801431,10.3921218 0.115901897,10.1799834 C0.292683938,9.96784492 0.607966288,9.93918288 0.820104737,10.1159649 L6.371,14.741 L15.0712661,0.242827686 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.8101a59287b196c275612bbb65d05c47.svg";
export { ForwardRef as ReactComponent };